<template>
  <b-modal
    v-model="isShow"
    centered
    title="Chọn đối tượng cần giao việc"
    no-close-on-backdrop
    @close="onClose"
  >
    <b-form>
      <div>
        <b-form-group label-cols-sm="4" content-cols-sm label="Đối tượng">
          <b-form-select
            v-model="objectType"
            size="sm"
            :options="[
              { value: 'OTHER_REGION', text: 'Trái vùng' },
              { value: 'STAFF', text: 'Nhân viên' },
            ]"
            @change="onChangeObjectType"
          />
        </b-form-group>
      </div>
      <div>
        <b-form-group
          label-cols-sm="4"
          content-cols-sm
          label="Người xử lý"
          :description="isLoading ? 'Loading...' : ''"
        >
          <SearchStaffAutocomplete
            v-model="staffSelected"
            :disabled="isLoading || listStaff.length === 0"
            :list="listStaff"
          />
        </b-form-group>
      </div>
    </b-form>
    <template #modal-footer>
      <div class="d-flex justify-content-end">
        <b-button variant="danger" @click="isShow = false"> Huỷ bỏ </b-button>
        <b-button variant="primary" :disabled="!staffSelected" @click="onSubmit">
          Xác nhận
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { SearchStaff, GetUserByType } from '@/services/customer-support/staff'
  import { showMess } from '@/config/utils'
  import SearchStaffAutocomplete from '@/components/cskh/SearchStaffAutocomplete.vue'

  export default {
    name: 'ShowImage',
    components: {
      SearchStaffAutocomplete,
    },
    props: {
      submit: {
        type: Function,
        default: () => {},
      },
      isUpdate: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isShow: false,
        isLoading: false,
        currentUser: null,
        objectType: 'OTHER_REGION',
        listStaff: [],
        staffSelected: null,

        staffSettings: {
          ajax: {
            delay: 100,
            transport: (params, success) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: this.listStaff?.slice(0, 10) || [],
                })
              }
              success({
                results: this.listStaff
                  .filter(user => {
                    return user.text.toLowerCase().indexOf(txtSearch.toLowerCase()) > -1
                  })
                  .slice(0, 10),
              })
            },
          },
        },
      }
    },

    created() {
      this.currentUser = JSON.parse(localStorage.getItem('userData'))
    },

    methods: {
      show() {
        this.isShow = true
        if (this.listStaff?.length === 0) {
          this.loadData()
        }
      },

      close() {
        this.isShow = false
      },

      onClose() {
        if (this.successCount) this.$emit('close')
      },

      async loadData() {
        try {
          this.isLoading = true
          if (this.objectType === 'OTHER_REGION') {
            const res = await GetUserByType(this.currentUser?.typeSale)
            if (res.code === 1000) {
              this.listStaff =
                res.data.map(user => {
                  return {
                    id: user.id,
                    text: `${user.name} - ${user.email}`,
                  }
                }) || []
            } else {
              this.listStaff = []
              showMess(this, 'error', res.message)
            }
          } else if (this.objectType === 'STAFF') {
            const res = await SearchStaff({})
            if (res.code === 1000) {
              this.listStaff =
                res.data.map(user => {
                  return {
                    id: user.id,
                    text: `${user.name} - ${user.userName}`,
                  }
                }) || []
            } else {
              this.listStaff = []
              showMess(this, 'error', res.message)
            }
          }
        } catch (error) {
          showMess(this, 'error', error)
        } finally {
          this.isLoading = false
        }
      },

      async onChangeObjectType() {
        this.staffSelected = null
        this.loadData()
      },

      onSubmit() {
        this.isShow = false
        const newData = this.listStaff.find(item => item.id === this.staffSelected)
        this.$emit('submit', {
          objectType: this.objectType,
          staffSelected: newData,
        })
      },
    },
  }
</script>

<style scoped>
  .btn + .btn {
    margin-left: 10px;
  }
</style>
